export enum POI_STATUS {
  NONE = 0,
  ACTIVE = 10,
  COMPLETE = 20,
} // * What state is the POI currently in. Use for blocking certain behaviours. Also used by contentGroup state
export const enum QUEST_STEPS {
  NONE = 0,
  FOUND = 10,
  CG_START = 20,
  DIALOG1 = 30,
  MINIGAME = 40,
  DIALOG2 = 50,
  CG_END = 1000,
}

export enum QUEST_CG_SECTIONS {
  DIALOG1 = "d1",
  MINIGAME = "mg",
  DIALOG2 = "d2",
  EXIT_GOALS = "exitGoals",
}
// * QUESTS
export enum Q_QUEST_TYPE {
  MAIN = 0,
  PRIMARY = 10,
  SECONDARY = 20,
  MISC = 30,
}
export enum Q_QUEST_STATUS {
  NONE = 0,
  UNLOCKED = 10,
  ACTIVE = 20,
  COMPLETE = 30,
  FAILED = 40,
  CANCELLED = 50,
  FINAL = 900,
  DONE = 1000,
}

// * POIs
export enum Q_POI_STATUS {
  NONE = 0,
  FOUND = 10,
  ACTIVE = 20,
  COMPLETE = 30,
}

export enum GAME_STATUS {
  WIN = "win",
  FAIL = "fail",
  ACTIVE = "active",
  EXPIRED = "expired",
  NONE = "none",
}

// * What state is the POI currently in. Use for blocking certain behaviours. Also used by contentGroup state
// * POI.contentgroups

export const InitialCgID = "cg0";
export const enum Q_CG_STEPS {
  NONE = 0,
  CG_START = 10,
  DIALOG1 = 20,
  MINIGAME = 30,
  DIALOG2 = 40,
  CG_END = 1000,
}
export enum Q_CG_SECTIONS {
  DIALOG1 = "d1",
  MINIGAME = "mg",
  DIALOG2 = "d2",
  EXIT_GOALS = "exitGoals",
}
